import Add from '@mui/icons-material/Add';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import ConfigurationField from './ConfigurationField';
import SectionHeader from './SectionHeader';
import {
  SECTION_BOTTOM_MARGIN,
  SECTION_GRID_SPACING,
} from '../paymentsManagerConfiguration.constants';

const ReconFoldersSection = ({
  reconPaths,
  fieldErrors,
  onAdd,
  onUpdate,
  onRemove,
  disabled,
}) => (
  <>
    <SectionHeader
      action={
        <Button
          size='small'
          startIcon={<Add />}
          disabled={disabled}
          onClick={onAdd}>
          Add folder
        </Button>
      }>
      Inbound recon folders
    </SectionHeader>
    {fieldErrors.recon_paths && (
      <Typography variant='caption' color='error' sx={{ display: 'block' }}>
        {fieldErrors.recon_paths}
      </Typography>
    )}
    <Grid
      container
      spacing={SECTION_GRID_SPACING}
      sx={{ mb: SECTION_BOTTOM_MARGIN }}>
      {reconPaths.map((path, index) => (
        <Grid item xs={12} md={6} key={path.id}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <ConfigurationField
              name={`recon_paths[${index}]`}
              label={`Recon folder ${index + 1}`}
              value={path.value}
              onChange={(event) => onUpdate(index, event.target.value)}
              error={fieldErrors[`recon_paths[${index}]`]}
              tooltip='Inbound SFTP folder containing reconciliation files, for example /recon/'
              disabled={disabled}
            />
            <IconButton
              aria-label={`Remove recon folder ${index + 1}`}
              color='error'
              disabled={disabled || reconPaths.length === 1}
              onClick={() => onRemove(path.id)}
              sx={{ mt: 0.5 }}>
              <DeleteOutline />
            </IconButton>
          </Box>
        </Grid>
      ))}
    </Grid>
  </>
);

export default ReconFoldersSection;
